import React, { useState, useRef, MouseEvent as ReactMouseEvent } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Breadcrumb, Grid, Header, Button, Icon, Segment, Input } from 'semantic-ui-react';
import { SectionCard, SectionData } from './SectionCard';
import { useManageHomepageSections } from './useManageHomepageSections';

type DragData = {
    initialOffsetLeft: number;
    initialOffsetTop: number;
    dragOffsetX: number;
    dragOffsetY: number;
    currWidth: number;
    currHeight: number;
}

export function ManageHomepageSections() {
    const history = useHistory();
    const defaultDragData: DragData = {
        initialOffsetLeft: 0,
        initialOffsetTop: 0,
        dragOffsetX: 0,
        dragOffsetY: 0,
        currWidth: 0,
        currHeight: 0
    }

    const [sectionsData, isLoading, setSectionsData, saveOrder] = useManageHomepageSections();

    const dragData = useRef<DragData>(defaultDragData);
    const draggingDom = useRef<HTMLElement | null>(null);
    const shadowDom = useRef<HTMLElement | null>(null);
    const isDragging = useRef<boolean>(false);
    const draggingId = useRef<number>(0);



    const handleCreateNewSection = (event: ReactMouseEvent) => {
        history.push('/editHomepageSection/0');
    };

    function handleMousedown(e: MouseEvent, sectionId: number) {
        let targetDom = document.getElementById(`section-card-${sectionId}`);
        draggingDom.current = targetDom;
        draggingId.current = sectionId;
        if (targetDom) {
            targetDom.classList.add('in-drag');
            dragData.current.initialOffsetLeft = targetDom.offsetLeft;
            dragData.current.initialOffsetTop = targetDom.offsetTop;
            isDragging.current = true;
            dragData.current.dragOffsetX = 0 - e.clientX;
            dragData.current.dragOffsetY = 0 - e.clientY;
            const cssObj = window.getComputedStyle(targetDom, null);
            //console.log(cssObj.width);
            //console.log(cssObj.height);
            //console.log(targetDom.offsetLeft);
            //console.log(targetDom.offsetTop);
            //console.log(dragData.current.dragOffsetX);
            //console.log(dragData.current.dragOffsetY);
            //console.log(e.clientX);
            //console.log(e.clientY);
            //console.log(targetDom.getBoundingClientRect());
            let clientRect: DOMRect = targetDom.getBoundingClientRect();
            dragData.current.currWidth = parseInt(cssObj.width);
            dragData.current.currHeight = parseInt(cssObj.height); 
            shadowDom.current = document.createElement('div');
            shadowDom.current.style.position = 'fixed';
            shadowDom.current.style.left = `${clientRect.left}px`;
            shadowDom.current.style.borderRadius = '18px';
            shadowDom.current.style.top = `${clientRect.top}px`;
            shadowDom.current.style.height = `${clientRect.height}px`;
            shadowDom.current.style.width = `${clientRect.width}px`;
            shadowDom.current.style.border = `1px dashed red`;
            document.body.appendChild(shadowDom.current);
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        }
    }

    function onMouseMove(this: Document, e: MouseEvent): void {
        e.stopPropagation();
        e.preventDefault();
        //console.log(e);
        let mousePosition = {
            x: e.clientX,
            y: e.clientY
        };
        if (draggingDom.current != null) {
            draggingDom.current.style.left = (mousePosition.x + dragData.current.dragOffsetX) + 'px';
            draggingDom.current.style.top = (mousePosition.y + dragData.current.dragOffsetY) + 'px';
        }
    }

    function onMouseUp(this: Document, e: MouseEvent): void {
        e.stopPropagation();
        e.preventDefault();
        if (isDragging.current === true) {
            isDragging.current = false;
            if (shadowDom.current) {
                document.body.removeChild(shadowDom.current);
            }
            if(draggingDom.current){
                draggingDom.current.style.top = '0px';
                draggingDom.current.style.left = '0px';
                draggingDom.current.classList.remove('in-drag');
            }
            draggingId.current = 0;
            shadowDom.current = null;
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('mousemove', onMouseMove);
            saveOrder();
        }
    }

    function onDropEnter(sectionId: number) {
        let sourceIndex = -1;
        for(let i=0;i<sectionsData.length;i++){
            if(sectionsData[i].homepageSectionId === draggingId.current){
                sourceIndex = i;
            }
        }
        let targetIndex = -1;
        for(let i=0;i<sectionsData.length;i++){
            if(sectionsData[i].homepageSectionId === sectionId){
                targetIndex = i;
            }
        }
        let tempSectionData = {...sectionsData[targetIndex]};
        sectionsData[targetIndex] = {...sectionsData[sourceIndex]};
        sectionsData[sourceIndex] = {...tempSectionData};
        setSectionsData([...sectionsData]);
    }
    return (<>
        <Container style={{ position: 'relative' }}>
            <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem', display: 'inline-block' }}>Manage Home Page Sections</Header>
            <Button icon labelPosition='left' onClick={handleCreateNewSection} style={{ position: 'absolute', right: '0', top: '2.3rem' }}>
                <Icon name='plus' />
                Add a new section
            </Button>
            <hr style={{ marginBottom: '1.0rem' }} />
            <Breadcrumb style={{ marginBottom: '1.0rem' }}>
                <Breadcrumb.Section link><Link to='/dashboard'>Home</Link></Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section active>Manage Home Page Sections</Breadcrumb.Section>
            </Breadcrumb>
            <div className='admin-homepage-section-container'>
                {
                    sectionsData && sectionsData.length > 0 && sectionsData.map((item: SectionData, index) => {
                        return <SectionCard sectionData={item} key={index} onMouseDown={handleMousedown}
                            draggingId = {draggingId}
                            onDropEnter={onDropEnter}
                        isDragging={isDragging}></SectionCard>
                    })
                }
            </div>

        </Container>
    </>);
}